import { render, staticRenderFns } from "./advancedSetting.vue?vue&type=template&id=383edd44&scoped=true&"
import script from "./advancedSetting.vue?vue&type=script&lang=ts&"
export * from "./advancedSetting.vue?vue&type=script&lang=ts&"
import style0 from "./advancedSetting.vue?vue&type=style&index=0&id=383edd44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383edd44",
  null
  
)

export default component.exports